export default function Terms() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f0fdf4 0%, #ffffff 60%)",
      padding: "48px 24px",
      fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
      color: "#111827"
    }}>
      <div style={{ maxWidth: 780, margin: "0 auto" }} data-testid="terms-page" dir="ltr">
        <a href="/" style={{ color: "#047857", textDecoration: "none", fontWeight: 600 }}>← SocialHub</a>

        <h1 style={{ fontSize: 40, fontWeight: 800, marginTop: 24, marginBottom: 8 }}>
          Terms of Service
        </h1>
        <p style={{ color: "#6b7280", marginBottom: 32 }}>Last updated: February 2026</p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24 }}>1. Acceptance of Terms</h2>
        <p style={{ lineHeight: 1.7 }}>
          By using SocialHub (app.letsm.io), you agree to these Terms. If you do not agree, do not use the service.
        </p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24 }}>2. Service Description</h2>
        <p style={{ lineHeight: 1.7 }}>
          SocialHub is an omnichannel customer service platform that lets businesses connect Facebook, Instagram,
          WhatsApp, Telegram and other channels into a unified inbox with AI auto-reply capabilities.
        </p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24 }}>3. User Responsibilities</h2>
        <p style={{ lineHeight: 1.7 }}>
          You are responsible for maintaining the confidentiality of your account credentials and for all
          activities that occur under your account. You must comply with Meta Platform Terms, WhatsApp Business
          Messaging Policy, and all applicable laws when using connected channels.
        </p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24 }}>4. Data & Privacy</h2>
        <p style={{ lineHeight: 1.7 }}>
          We store only the minimum data required to operate the service (page tokens, inbox IDs, message
          metadata). See our <a href="/data-deletion" style={{ color: "#047857" }}>Data Deletion</a> page for
          your rights and process to remove data.
        </p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24 }}>5. Payment & Billing</h2>
        <p style={{ lineHeight: 1.7 }}>
          Paid plans are billed in advance. Wallet balances are non-refundable except where required by law.
          You may cancel your subscription at any time from the billing page.
        </p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24 }}>6. Termination</h2>
        <p style={{ lineHeight: 1.7 }}>
          We may suspend or terminate accounts that violate these Terms or platform policies (Meta, WhatsApp).
        </p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24 }}>7. Contact</h2>
        <p style={{ lineHeight: 1.7 }}>
          Questions? Email <a href="mailto:support@letsm.io" style={{ color: "#047857" }}>support@letsm.io</a>.
        </p>
      </div>
    </div>
  );
}
